'use strict';

var _ = require('lodash');
var angular = require('angular');
var toastr = require('toastr');
function SaveScheduleChangeService($q, managedEntitiesService, hepService, configurationService, seasonalitySponsorshipService, bootstrapService, featureToggleService, UserSecureService, UserManagementDataService, restangular) {
  function getMarketLocalValue(isSignificant) {
    return featureToggleService.isEnabled('MARKET_LOCAL_INDICATOR') ? true : isSignificant;
  }
  function handleError(event) {
    angular.element('#review-rules-error-modal').modal('show');
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
  }
  function getMarket(market, significantManagedEntities) {
    var newMarket = {};
    newMarket.origin = market.origin;
    newMarket.destination = market.destination;
    var controlType = _.result(_.find(significantManagedEntities, {
      origin: market.origin,
      destination: market.destination
    }), 'controlType') || market.controlType;
    newMarket.controlType = featureToggleService.isEnabled('FINANCIAL_CONTROLS') ? controlType : 'physical';
    newMarket.isSignificant = featureToggleService.isEnabled('SML') ? market.isSignificant === 'true' : false;
    if (featureToggleService.isEnabled('BREAK_CONNECTIONS')) {
      newMarket.isSignificant = true;
    }
    newMarket.isNew = false;
    newMarket.isLocal = getMarketLocalValue(newMarket.isSignificant);
    newMarket.owner = _.get(market, 'owner', '');
    if (featureToggleService.isEnabled('SEGMENT_CLASS_CONTROL')) {
      var sponsor = _.first(market.significantPos).sponsor;
      if (sponsor) {
        newMarket.isTrafficRestricted = !!sponsor.isTrafficRestricted;
      }
    }
    return newMarket;
  }
  function getAssignedUser(entity) {
    if (entity._old && entity.owner !== entity._old) {
      return {
        assignee: entity._old,
        market: entity.market
      };
    }
  }
  function getNewMarketUser(entity) {
    if (!entity._old || entity.owner !== entity._old) {
      return {
        assignee: entity.owner,
        market: entity.market
      };
    }
  }
  function getHepMarketEntity(market) {
    return {
      type: 'MarketEntity',
      attributes: {
        origin: market.origin,
        destination: market.destination
      },
      properties: {
        entityName: market.assignedEntity || 'Default'
      }
    };
  }
  function getLeg(leg) {
    var newLeg = {};
    newLeg.origin = leg.origin;
    newLeg.entity = leg.entity;
    newLeg.isNew = leg.isNew;
    newLeg.destination = leg.destination;
    newLeg.owner = _.get(leg, 'owner', '');
    newLeg.isNotSaved = leg.isNotSaved;
    return newLeg;
  }
  function getAssignedLegUser(entity) {
    if (entity._old && entity.owner !== entity._old) {
      return {
        assignee: entity._old,
        leg: entity.leg
      };
    }
  }
  function getNewLegUser(entity) {
    if (!entity._old || entity.owner !== entity._old) {
      return {
        assignee: entity.owner,
        leg: entity.leg
      };
    }
  }
  function getPos(market, significantPos) {
    var pos = {};
    pos.priority = significantPos.priority;
    pos.country = significantPos.country;
    pos.origin = market.origin;
    pos.city = significantPos.city;
    pos.iataStart = significantPos.iataFrom;
    pos.iataEnd = significantPos.iataTo;
    pos.destination = market.destination;
    pos.spos = significantPos.spos;
    return pos;
  }
  function getHostShare(market, marketShare, significantPos) {
    var hostShare = {};
    hostShare.origin = marketShare.origin || market.origin;
    hostShare.destination = marketShare.destination || market.destination;
    hostShare.significantPOS = marketShare.significantPOS || significantPos.spos;
    hostShare.dayOfWeek = marketShare.dayOfWeek;
    hostShare.hostShare = marketShare.share / 100;
    hostShare.hepKey = marketShare.hepKey;
    return hostShare;
  }
  function getScenarioName(sponsorOrigin, sponsorDestination, calendarName, origin, destination) {
    return ['AVRO', sponsorOrigin, sponsorDestination, calendarName, origin, destination].join('-');
  }
  function getCalendarName(sponsorOrigin, sponsorDestination, calendarName) {
    return [sponsorOrigin, sponsorDestination, calendarName].join('-');
  }
  function getCalendarNameFromSeasonalityAnalysis(sourceOrigin, sourceDestination, type) {
    var filters = [];
    filters.push('origin==' + sourceOrigin);
    filters.push('destination==' + sourceDestination);
    filters.push('domainName==LegShowUpMetrics');
    filters.push('active==true');
    return restangular.one('partitioned/seasonality').all('analysis').get('?filter=' + filters.join(';')).then(function (data) {
      if (data && data.analysis && data.analysis.length > 0) {
        return _.first(data.analysis).calendarName;
      }
    }, function (err) {
      if (err) {
        toastr.warning('Cannot find forecast profiles for source ' + type);
      }
    });
  }
  function saveClassGroupConfigs(hepConfigs) {
    hepConfigs = _.compact(hepConfigs);
    return hepConfigs.length && hepService.addHep(hepConfigs);
  }
  function takeClassGroupConfigToUpdate(classGroupConfigs, market) {
    classGroupConfigs = _.compact(classGroupConfigs);
    if (!classGroupConfigs.length) {
      return;
    }
    return _.assign({}, _.head(classGroupConfigs), {
      attributes: {
        origin: market.origin,
        destination: market.destination
      }
    });
  }
  function buildServiceClassGroupConfigEntry(serviceClassGrpConfig) {
    if (serviceClassGrpConfig && serviceClassGrpConfig.length) {
      return {
        type: 'ServiceClassGroupConfig',
        properties: {
          serviceClassGroupConfigParams: serviceClassGrpConfig
        }
      };
    }
  }
  function getSponsorClassGroupConfig(significantPos) {
    var sponsor = significantPos.sponsor;
    var classGroupConfig = configurationService.getClassGroupConfig();
    return sponsor && buildServiceClassGroupConfigEntry(classGroupConfig[sponsor.origin + '-' + sponsor.destination]);
  }
  function saveShowUpInitProfilesWithLegSponsorship(leg) {
    var sponsorOrigin = leg.sponsor.origin;
    var sponsorDestination = leg.sponsor.destination;
    return getCalendarNameFromSeasonalityAnalysis(sponsorOrigin, sponsorDestination, 'leg').then(function (calendarName) {
      if (!calendarName) {
        toastr.warning('Cannot find forecast profiles for source market');
        return;
      }
      return hepService.getShowUpInitProfiles(sponsorOrigin, sponsorDestination).then(function (data) {
        if (data && data.hepList) {
          var profiles = _.chain(data.hepList).filter(function (p) {
            return _.isUndefined(p.attributes.legBusinessId);
          }).map(function (p) {
            delete p.hepKey;
            p.properties.profile.sponsor = sponsorOrigin + '-' + sponsorDestination;
            p.attributes.legOrigin = leg.origin;
            p.attributes.legDestination = leg.destination;
            p.attributes.scenarioName = getScenarioName(sponsorOrigin, sponsorDestination, calendarName, leg.origin, leg.destination);
            p.properties.profile.calendarName = getCalendarName(sponsorOrigin, sponsorDestination, p.properties.profile.calendarName);
            return p;
          }).value();
          return managedEntitiesService.addSponsorHep(profiles);
        }
      });
    });
  }
  function saveShowUpInitProfilesWithFlightSponsorship(leg, flightSponsor) {
    var sponsorOrigin = flightSponsor.selected.origin;
    var sponsorDestination = flightSponsor.selected.destination;
    var businessId = flightSponsor.businessId;
    return getCalendarNameFromSeasonalityAnalysis(sponsorOrigin, sponsorDestination, 'leg').then(function (calendarName) {
      if (!calendarName) {
        toastr.warning('Cannot find forecast profiles for source market');
        return;
      }
      return hepService.getShowUpInitProfiles(sponsorOrigin, sponsorDestination, businessId).then(function (data) {
        if (data && data.hepList) {
          var profiles = _.chain(data.hepList).filter(function (p) {
            return !_.isUndefined(p.attributes.legBusinessId);
          }).map(function (p) {
            delete p.hepKey;
            p.properties.profile.sponsor = sponsorOrigin + '-' + sponsorDestination + '-' + businessId;
            p.attributes.legOrigin = leg.origin;
            p.attributes.legDestination = leg.destination;
            p.attributes.legBusinessId = leg.origin + '-' + leg.destination + '#' + flightSponsor.sourceBusinessId;
            p.attributes.scenarioName = getScenarioName(sponsorOrigin, sponsorDestination, calendarName, leg.origin, leg.destination);
            p.properties.profile.calendarName = getCalendarName(sponsorOrigin, sponsorDestination, p.properties.profile.calendarName);
            return p;
          }).value();
          return managedEntitiesService.addSponsorHep(profiles);
        }
      });
    });
  }
  function retainExistingShowUpInitProfiles(leg) {
    var sponsorLeg = _.first(leg.flightSponsor).selected;
    var sponsorOrigin = sponsorLeg.origin;
    var sponsorDestination = sponsorLeg.destination;
    var legBusinessIds = _.map(leg.flightSponsor, function (flightSponsor) {
      return leg.origin + '-' + leg.destination + '#' + flightSponsor.sourceBusinessId;
    });
    return getCalendarNameFromSeasonalityAnalysis(sponsorOrigin, sponsorDestination, 'leg').then(function (calendarName) {
      if (!calendarName) {
        toastr.warning('Cannot find forecast profiles for source market');
        return;
      }
      return hepService.getShowUpInitProfiles(leg.origin, leg.destination).then(function (data) {
        if (data && data.hepList) {
          var profiles = _.chain(data.hepList).filter(function (p) {
            var legBusinessId = p.attributes.legBusinessId;
            return _.isUndefined(legBusinessId) || !_.includes(legBusinessIds, legBusinessId);
          }).map(function (p) {
            delete p.hepKey;
            p.attributes.scenarioName = getScenarioName(sponsorOrigin, sponsorDestination, calendarName, leg.origin, leg.destination);
            return p;
          }).value();
          return managedEntitiesService.addSponsorHep(profiles);
        }
      });
    });
  }
  function updateMarkets(markets) {
    return managedEntitiesService.updateMarket({
      'market': markets
    });
  }
  function saveMarketsEntity(marketEntity) {
    return managedEntitiesService.updateMarketEntity(marketEntity);
  }
  function updateLegs(legs) {
    if (legs && legs.length) {
      managedEntitiesService.updateLegs({
        'leg': legs
      })["catch"](function (error) {
        handleError(event, error);
      });
    }
  }
  function insertLegs(newLegs) {
    if (newLegs && newLegs.length) {
      managedEntitiesService.insertLegs({
        'leg': newLegs
      })["catch"](function (error) {
        handleError(event, error);
      });
    }
  }
  function saveFlightEntity(legs) {
    var legHeps = [];
    _.forEach(legs, function (leg) {
      var legHep = {
        attributes: {},
        properties: {}
      };
      legHep.type = 'FlightEntity';
      legHep.attributes.origin = leg.origin;
      legHep.attributes.destination = leg.destination;
      legHep.properties.entityName = leg.assignedEntity;
      legHeps.push(legHep);
    });
    managedEntitiesService.addFlightEntityHep(legHeps)["catch"](function (error) {
      handleError(event, error);
    });
  }
  function savePoses(poses) {
    return managedEntitiesService.updatePoses({
      'pos': poses
    });
  }
  function saveHostShares(hostShares) {
    return managedEntitiesService.updateHostShare(hostShares);
  }
  var reloadConfigurations = bootstrapService.load;
  function triggerSeasonalitySponsorships(seasonalitySponsorships) {
    seasonalitySponsorships = _.compact(seasonalitySponsorships);
    if (seasonalitySponsorships.length > 0) {
      seasonalitySponsorshipService.trigger(seasonalitySponsorships)["catch"](function (error) {
        handleError(event, error);
      });
    }
  }
  function getMarketSeasonalitySponsorship(market) {
    var sponsor = _.first(market.significantPos).sponsor;
    if (sponsor) {
      return {
        carrier: configurationService.getHostCarrier(),
        origin: market.origin,
        destination: market.destination,
        sponsorOrigin: market.significantPos[0].sponsor.origin,
        sponsorDestination: market.significantPos[0].sponsor.destination,
        domainName: 'UntruncatedMarketDemand',
        user: UserSecureService.getUserId()
      };
    }
  }
  function getFlightSeasonalitySponsorship(leg) {
    var sponsor = leg.sponsor || _.first(leg.flightSponsor).selected;
    if (sponsor) {
      return {
        carrier: configurationService.getHostCarrier(),
        origin: leg.origin,
        destination: leg.destination,
        sponsorOrigin: sponsor.origin,
        sponsorDestination: sponsor.destination,
        domainName: 'LegShowUpMetrics',
        user: UserSecureService.getUserId()
      };
    }
  }
  function updateUsers(toDeleteMarkets, toUpdateMarkets) {
    var deleteFromUser = _.groupBy(toDeleteMarkets, 'assignee');
    var appendToUser = _.groupBy(toUpdateMarkets, 'assignee');
    var promises = [];
    _.forEach(deleteFromUser, function (assignments, userId) {
      var markets = _.map(assignments, 'market');
      promises.push(UserManagementDataService.removeMarketResponsibilities(userId, markets));
    });
    _.forEach(appendToUser, function (assignments, userId) {
      var markets = _.map(assignments, 'market');
      promises.push(UserManagementDataService.addMarketResponsibilities(userId, markets));
    });
    return $q.all(promises);
  }
  function updateLegUsers(toDeleteLegs, toUpdateLegs) {
    var deleteFromUser = _.chain(toDeleteLegs).filter('assignee').groupBy('assignee').value();
    var appendToUser = _.chain(toUpdateLegs).filter('assignee').groupBy('assignee').value();
    var promises = [];
    _.forEach(deleteFromUser, function (assignments, userId) {
      var legs = _.map(assignments, 'leg');
      promises.push(UserManagementDataService.removeLegResponsibilities(userId, legs));
    });
    _.forEach(appendToUser, function (assignments, userId) {
      var legs = _.map(assignments, 'leg');
      promises.push(UserManagementDataService.addLegResponsibilities(userId, legs));
    });
    return $q.all(promises);
  }
  function responsibilityUserValid(user) {
    return user && user.assignee;
  }
  function saveMarket(payload) {
    return restangular.service('schedulechange/market/save').post({
      managedMarkets: payload
    }).then(function (response) {
      _.forEach(response.errors, function (err) {
        toastr.warning(err);
      });
    });
  }
  function saveMarketScheduleChange(managedEntities, significantManagedEntities) {
    var savePayload = [];
    var promises = [];
    var markets = [];
    var poses = [];
    var hostShares = [];
    var marketEntities = [];
    var classGroupConfigs = [];
    var seasonalitySponsorships = [];
    var userToRemoveResponsibility = [];
    var userToAddResponsibility = [];
    _.forEach(managedEntities, function (market) {
      var oldResponsibilityUser = getAssignedUser(market);
      var addResponsibilityUser = getNewMarketUser(market);
      if (responsibilityUserValid(oldResponsibilityUser)) {
        userToRemoveResponsibility.push(oldResponsibilityUser);
      }
      if (responsibilityUserValid(addResponsibilityUser)) {
        userToAddResponsibility.push(addResponsibilityUser);
      }
      markets.push(getMarket(market, significantManagedEntities));
      marketEntities.push(getHepMarketEntity(market));
      var marketClassGroupConfigs = [];
      _.forEach(market.significantPos, function (significantPos) {
        var sponsor = significantPos.sponsor;
        var demandPercentCopy = null;
        if (!_.isEmpty(sponsor)) {
          demandPercentCopy = _.isNull(sponsor.sponsorDemandPercentageCopy) || _.isUndefined(sponsor.sponsorDemandPercentageCopy) ? 100 : sponsor.sponsorDemandPercentageCopy;
        }
        savePayload.push({
          market: {
            origin: market.origin,
            destination: market.destination,
            spos: significantPos.spos
          },
          sponsor: {
            origin: sponsor.origin,
            destination: sponsor.destination,
            spos: sponsor.spos,
            sponsorDemandPercentageCopy: demandPercentCopy
          }
        });
        poses.push(getPos(market, significantPos));
        marketClassGroupConfigs.push(getSponsorClassGroupConfig(significantPos));
        _.forEach(significantPos.marketShare.data, function (marketShare) {
          if (marketShare.share && marketShare.share !== marketShare.hostShare) {
            hostShares.push(getHostShare(market, marketShare, significantPos));
          }
        });
      });
      classGroupConfigs.push(takeClassGroupConfigToUpdate(marketClassGroupConfigs, market));
      seasonalitySponsorships.push(getMarketSeasonalitySponsorship(market));
    });
    promises.push(updateUsers(userToRemoveResponsibility, userToAddResponsibility));
    promises.push(updateMarkets(markets));
    promises.push(saveMarketsEntity(marketEntities));
    promises.push(savePoses(poses));
    promises.push(saveHostShares(hostShares));
    promises.push(saveClassGroupConfigs(classGroupConfigs));
    promises.push(saveMarket(savePayload));
    return $q.all(promises).then(triggerSeasonalitySponsorships.bind(undefined, seasonalitySponsorships)).then(reloadConfigurations);
  }
  function saveFlightScheduleChange(managedEntities, significantManagedEntities) {
    var promises = [];
    var seasonalitySponsorships = [];
    var allLegs = _.map(managedEntities, getLeg);
    var partitionedLegs = _.partition(allLegs, function (leg) {
      return leg.isNotSaved;
    });
    var newLegs = partitionedLegs[0];
    var oldLegs = partitionedLegs[1];
    _.forEach(allLegs, function (leg) {
      leg.isNew = false;
      delete leg.isNotSaved;
    });
    promises.push(insertLegs(newLegs), updateLegs(oldLegs), saveFlightEntity(significantManagedEntities));
    var userToRemoveResponsibility = [];
    var userToAddResponsibility = [];
    _.forEach(managedEntities, function (leg) {
      var oldResponsibilityUser = getAssignedLegUser(leg);
      var addResponsibilityUser = getNewLegUser(leg);
      if (oldResponsibilityUser) {
        userToRemoveResponsibility.push(oldResponsibilityUser);
      }
      if (addResponsibilityUser) {
        userToAddResponsibility.push(addResponsibilityUser);
      }
      if (leg.sponsor) {
        promises.push(saveShowUpInitProfilesWithLegSponsorship(leg));
      } else {
        promises.push(retainExistingShowUpInitProfiles(leg));
      }
      _.forEach(leg.flightSponsor, function (flightSponsor) {
        promises.push(saveShowUpInitProfilesWithFlightSponsorship(leg, flightSponsor));
      });
      seasonalitySponsorships.push(getFlightSeasonalitySponsorship(leg));
    });
    promises.push(updateLegUsers(userToRemoveResponsibility, userToAddResponsibility));
    return $q.all(promises).then(triggerSeasonalitySponsorships.bind(undefined, seasonalitySponsorships)).then(reloadConfigurations);
  }
  return {
    saveMarketScheduleChange: saveMarketScheduleChange,
    saveFlightScheduleChange: saveFlightScheduleChange,
    handleError: handleError
  };
}
SaveScheduleChangeService.$inject = ['$q', 'ManagedEntitiesService', 'HepService', 'ConfigurationService', 'SeasonalitySponsorshipService', 'BootstrapService', 'FeatureToggleService', 'UserSecureService', 'UserManagementDataService', 'Restangular'];
module.exports = SaveScheduleChangeService;